import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

// Components
import LeaderboardItem from '../LeaderboardItem';

// Icons
import { HelpOutline as HelpOutlineIcon } from 'material-ui-icons';

// Utils
import { createSlugFromTitle } from '../../utils';

// Styles
import {
  Wrapper,
  LeaderboardWrapper,
  Header,
  Description,
  List,
  Expander
} from './LeaderboardStyles';

class Leaderboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      descriptionExpanded: false,
      listCollapsed: true
    };
    this._handleMoreTapped = this._handleMoreTapped.bind(this);
    this._handleExpandDescriptionTapped = this._handleExpandDescriptionTapped.bind(this);
  }

  _handleMoreTapped() {
    this.setState({
      listCollapsed: !this.state.listCollapsed
    });
  }

  _handleExpandDescriptionTapped() {
    this.setState({
      descriptionExpanded: !this.state.descriptionExpanded
    });
  }

  render() {
    const { listCollapsed, descriptionExpanded } = this.state;
    const { collapseAfter, items, split, title, description } = this.props;
    return (
      <Wrapper className={split ? '--split' : ''}>
        <LeaderboardWrapper>
          <Header>{title} <a title='Click to read a description of this list' onClick={this._handleExpandDescriptionTapped}><HelpOutlineIcon style={{ color: 'inherit', width: 20, height: 20 }} /></a></Header>
          <Description show={descriptionExpanded}>{description}</Description>
          <List>
            {items.map((item, i) => (!listCollapsed || i < collapseAfter) && (
              <LeaderboardItem
                key={`leaderboard-item-${i}`}
                index={i + 1}
                title={item.title}
                meta={item.meta}
                slug={createSlugFromTitle(item.title)} />
            ))}
            {collapseAfter < items.length
              && <Expander onClick={this._handleMoreTapped}>{listCollapsed ? 'More' : 'Less'}</Expander>}
          </List>
        </LeaderboardWrapper>
      </Wrapper>
    )
  }
};

Leaderboard.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  collapseAfter: PropTypes.number,
  split: PropTypes.bool
};

Leaderboard.defaultProps = {
  collapseAfter: 10,
  description: '',
  split: false
};

export default Leaderboard;



// WEBPACK FOOTER //
// ./src/components/Leaderboard/Leaderboard.jsx